import React, { useState, useRef } from "react";

import { aadhaarPay, balanceEnquiry } from "../../../api/aepsApi";
import { getLocation } from "../../../components/Navigator/Navigator";


import Main from "../../Main";
import AppBreadcrumbs from "../../../components/ui/AppBreadcrumbs";
import { useInactivityTimeout } from "../../../hooks/useInactivityTimeout";
import MiniStatementPopup from "./MiniStatementPopup";
import { useBankList } from "../../../context/authBankContext";
import FingerprintCapture from "../../../hooks/FingerprintCapture";
import FingerprintModal from "../../../hooks/FingerprintModal";
import { useFingerprintCapture } from "../../../hooks/useFingerprintCapture";
import { useNotify } from "../../../context/NotifyContext";
import { useDispatch, useSelector } from "react-redux";
import { setLocation } from "../../../features/authSlice";
import AepsPipeSelect from "../../../components/AepsPipeSelect";
const AadhaarPay = () => {
  const { notify } = useNotify();
    const { location: savedLocation } = useSelector((state) => state.auth); // get location from Redux
      const pipe = useSelector((s) => s.aeps.pipe); // get location from Redux
const dispatch = useDispatch();
const [fetchingLocation, setFetchingLocation] = useState(false);
  const [amountLoading, setAmountLoading] = useState(false);
    const {
    pidData,
    fpStatus,
    fingerLoading,
    step,
    error,
    captureFingerprint,
    resetFingerprint,
  } = useFingerprintCapture();
  const { banklist, aepsloading } = useBankList();
  const [form, setForm] = useState({
    aadhaar: "",
    mobile: "",
    bankiin: ""
  });

const validateForm = () => {
  // Aadhaar
  if (!form.aadhaar || !/^\d{12}$/.test(form.aadhaar)) {
    notify("Enter valid 12 digit Aadhaar number", "error");
    return false;
  }

  // Mobile (India rule)
  if (!form.mobile || !/^[6-9]\d{9}$/.test(form.mobile)) {
    notify("Enter valid 10 digit mobile number", "error");
    return false;
  }

  // Bank
  if (!form.bankiin) {
    notify("Please select bank", "error");
    return false;
  }

    if (!pipe) {
    notify("Please select BankPipe", "error");
    return false;
  }

  return true;
};


  const [loading, setLoading] = useState(false);
  const [balanceData, setBalanceData] = useState(null);
  const fetchedRef = useRef(false);

  // 🔐 Clear everything
  const clearSession = () => {
    setForm({
      aadhaar: "",
      mobile: "",
      bankiin: "",
    });
    setBalanceData(null);
    fetchedRef.current = false;
    resetFingerprint()
  };

  // ⏳ Auto session expire (10 min)
  useInactivityTimeout(() => {
    if (balanceData) {
      clearSession();
      notify("Session expired due to inactivity",'error');
    }
  }, 10 * 60 * 1000);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // numeric only for aadhaar & mobile
    if ((name === "aadhaar" || name === "mobile") && !/^\d*$/.test(value)) {
      return;
    }

    setForm({ ...form, [name]: value });
  };


 const submit = async (pid) => {
  if (!validateForm()) return;

  if (!pid) {
    notify("Fingerprint required", "error");
    return;
  }

  if (fetchedRef.current) return;

  try {
   setFetchingLocation(true);
  let location;

  try {
    // ✅ Check Redux first
    if (savedLocation) {
      location = savedLocation;
    } else {
      // ✅ If not in Redux, fetch geolocation
      location = await getLocation();
      dispatch(setLocation(location)); // store in Redux for future use
    }
  } catch {
    setFetchingLocation(false);
    return notify("Location permission required", "error");
  }

  setFetchingLocation(false);

    const payload = {
      aadhaar: form.aadhaar,
      mobile: form.mobile,
      bankiin: form.bankiin,
      pidData: pid,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const result = await balanceEnquiry(payload);

    if (result?.data?.status === true) {
      setBalanceData(result.data);
      fetchedRef.current = true;
      notify("Balance fetched successfully", "success");
    } else {
      notify(result?.data?.message || "Balance enquiry failed", "error");
    }
  } catch {
    notify("Server / Network error", "error");
  }
};




const handleAmountFromPopup = async (amount) => {
  const enteredAmount = Number(amount);

  if (!enteredAmount || isNaN(enteredAmount) || enteredAmount <= 0) {
    notify("Enter valid transaction amount", "error");
    return;
  }

  if (!validateForm()) return;

  if (!pidData) {
    notify("Fingerprint required", "error");
    return;
  }

  setAmountLoading(true);

  try {
  setFetchingLocation(true);
  let location;

  try {
    // ✅ Check Redux first
    if (savedLocation) {
      location = savedLocation;
    } else {
      // ✅ If not in Redux, fetch geolocation
      location = await getLocation();
      dispatch(setLocation(location)); // store in Redux for future use
    }
  } catch {
    setFetchingLocation(false);
    return notify("Location permission required", "error");
  }

  setFetchingLocation(false);

    const payload = {
      aadhaar: form.aadhaar,
      mobile: form.mobile,
      amount: enteredAmount,
      bankiin: balanceData?.bankiin || form.bankiin,
      pidData,
      pipe,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const result = await aadhaarPay(payload);

    if (result?.data?.status === true) {
      notify(result?.data?.message || "AadhaarPay successful", "success");
      clearSession();
    } else {
      notify(result?.message || "AadhaarPay failed", "error");
    }
  } catch {
    notify("Server error", "error");
  } finally {
    setAmountLoading(false);
  }
};

  const handleBankChange = (e) => {
  const value = e.target.value;
  setForm(prev => ({
    ...prev,
    bankiin: value
  }));
};


const handleAddBeneficiaryClick = async () => {
  if (!validateForm()) return;

  try {
    setLoading(true);

    const pid = await captureFingerprint(pipe);
    if (!pid) {
      notify("Fingerprint capture cancelled", "error");
      return;
    }

    await submit(pid);
  } finally {
    setLoading(false);
  }
};


  return (
    <Main showRightPanel={false}>
      <AppBreadcrumbs
        items={[
          { label: "Dashboard", to: "/" },
          { label: "Aadhaar" },
          { label: "Aadhaar Pay" },
        ]}
      />

      <div className="flex flex-col lg:flex-row gap-6">
        <div className="ds-card w-full max-w-sm">
          <h2 className="text-sm font-semibold mb-4 text-[var(--text-dark)]">
            Aadhaar Pay
          </h2>

          <form onSubmit={submit} className="space-y-4">

{fpStatus === "success" && !balanceData && (
  <div className="make-text-primary text-sm">
    ✔ Fingerprint verified, fetching data...
  </div>
)}

{fpStatus === "error" && (
  <div className="text-[var(--error-color)] text-sm">{error}</div>
)}

<AepsPipeSelect />
<select
  className="ds-input text-sm"
  value={form.bankiin}
  onChange={handleBankChange}
  disabled={aepsloading}
>
  <option value="">
    {aepsloading ? "Loading Banks..." : "Select Bank Name"}
  </option>

{banklist.map((bank, index) => (
  <option
    key={`${bank.iinno}-${index}`}
    value={bank.iinno}
  >
    {bank.bankName}
  </option>
))}

</select>

            <div>
              <label className="ds-label">Aadhaar Number</label>
              <input
                name="aadhaar"
                required
                maxLength={12}
                value={form.aadhaar}
                onChange={handleChange}
                className="ds-input"
                placeholder="Aadhaar Number"
              />
            </div>

            <div>
              <label className="ds-label">Mobile Number</label>
              <input
                name="mobile"
                required
                maxLength={10}
                value={form.mobile}
                onChange={handleChange}
                className="ds-input"
                placeholder="Mobile Number"
              />
            </div>

          <button
  type="button"
  className="ds-btn ds-btn-primary w-full"
  onClick={handleAddBeneficiaryClick}
  disabled={fingerLoading || loading || balanceData}
>
  {fingerLoading
    ? "Capturing Fingerprint..."
    : loading
    ? "Don't Refresh..."
    : "Check Balance"}
</button>
          </form>
        </div>

         <FingerprintModal open={fingerLoading} step={step} />

        {balanceData && (
          <MiniStatementPopup
            details={balanceData}
            close={clearSession}
             onSubmitAmount={handleAmountFromPopup}
             loading={amountLoading}
          />
        )}
      </div>
    </Main>
  );
};

export default AadhaarPay;
